const mapAssets = {
  Smoke: require("../assets/background/smoke.jpeg"),
  Rain: require("../assets/background/rain.jpeg"),
  Snow: require("../assets/background/snow.jpeg"),
  Clear: require("../assets/background/clear.jpeg"),
  Extreme: require("../assets/background/extreme.jpeg"),
  Thunderstorm: require("../assets/background/thunderstorm.jpeg"),
  Drizzle: require("../assets/background/drizzle.jpeg"),
  Mist: require("../assets/background/mist.jpeg"),
  Haze: require("../assets/background/haze.jpeg"),
  Dust: require("../assets/background/dust.jpeg"),
  Fog: require("../assets/background/fog.jpeg"),
  Squall: require("../assets/background/squall.jpeg"),
  Clouds: require("../assets/background/clouds.jpeg"),
};

export default mapAssets;
